import { Injectable,  } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor,HttpHeaders } from '@angular/common/http';
import { Observable, throwError  } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DataService } from '../../_service/data.service';
import { Router } from '@angular/router';


@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
    
    constructor(
        private dataService: DataService,
        private router: Router
        ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (this.dataService.getCookies('loginData') || localStorage.getItem('loginData')) {
        let loginData = (this.dataService.getCookies('loginData'))? JSON.parse(this.dataService.getCookies('loginData')) : JSON.parse(localStorage.getItem('loginData'));
        
        if (loginData && loginData.token) {
            if (new Date(loginData.expiryDate) <= new Date()) {
                
                this.dataService.removeCookies('loginData', 'token');
                localStorage.removeItem('loginData')
                this.dataService.showError('Session Expired.');
                this.router.navigateByUrl('/home');
            }
                req = req.clone({
                    setHeaders: {
                        'Authorization': `Bearer ${loginData.token}`
                    }
                });
            
        }
    }

        return next.handle(req)
    }
}